import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

// Reference getCardValue: K=13, Q=12, J=11, A=1, else the number (10 from a 4-char token)
function cardValue(token) {
  let v = token.length === 4 ? token.slice(0, 2) : token.slice(0, 1);
  if (v === "K") v = 13;
  if (v === "Q") v = 12;
  if (v === "J") v = 11;
  if (v === "A") v = 1;
  return parseInt(v, 10) || 0;
}

/**
 * Reference result body for Queen (bootstrap-vue result modal, type "queen"):
 * cards dealt round-robin to Total 0..3 ("1" skipped, slot still advances), count starts at
 * the total's index; "Winner" label after the winning total's cards; rdesc[0] as Winner.
 */
export default function QueenResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const players = [0, 1, 2, 3].map((i) => ({ count: i, cards: [] }));
  cards.forEach((c, idx) => {
    if (c === "1") return;
    const p = players[idx % 4];
    p.cards.push(c);
    p.count += cardValue(c);
  });
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const shown = players.map((p, i) => ({ ...p, i })).filter((p) => p.cards.length);

  return (
    <div className="row row5 card32result">
      <div className="col-12 col-lg-12">
        <div className="row row5">
          {shown.map((p, k) => (
            <React.Fragment key={p.i}>
              {k > 0 && " "}
              <div className="col-12 col-lg-12">
                <div className="casino-result-cards">
                  <h4 className="text-center">
                    {`Total ${p.i} - `}
                    <span className="badge badge-success font14">{p.count}</span>
                  </h4>{" "}
                  {p.cards.map((c, ci) => (
                    <div key={ci} className="casino-result-cards-item">
                      <img src={getCardImage(c)} />
                    </div>
                  ))}{" "}
                  {win === String(p.i + 1) && (
                    <div className="casino-result-cards-item d-block mt-3">
                      <span className="winner-label">Winner</span>
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>{" "}
      <div className="col-12 col-lg-12">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
